import { render, staticRenderFns } from "./nameTag.vue?vue&type=template&id=70cba818&scoped=true&"
import script from "./nameTag.vue?vue&type=script&lang=js&"
export * from "./nameTag.vue?vue&type=script&lang=js&"
import style0 from "./nameTag.vue?vue&type=style&index=0&id=70cba818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cba818",
  null
  
)

export default component.exports